import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { BadInputError, Result, UseCase } from '@digibricks/core';
export var CANCEL_QUESTION_USE_CASE = 'CANCEL_QUESTION_USE_CASE';
export var CancelQuestionUseCase = /*#__PURE__*/function (_UseCase) {
  _inherits(CancelQuestionUseCase, _UseCase);

  var _super = _createSuper(CancelQuestionUseCase);

  function CancelQuestionUseCase() {
    _classCallCheck(this, CancelQuestionUseCase);

    return _super.apply(this, arguments);
  }

  _createClass(CancelQuestionUseCase, [{
    key: "buildUseCase",
    value: function () {
      var _buildUseCase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(input) {
        var revertedQuestion, newQuestion, questions, nextQuestion;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                revertedQuestion = input.revertedQuestion, newQuestion = input.newQuestion, questions = input.questions;

                if (!revertedQuestion) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return", Result.ok({
                  canceledQuestion: revertedQuestion.clone()
                }));

              case 3:
                if (!newQuestion) {
                  _context.next = 10;
                  break;
                }

                newQuestion.deActivate();
                nextQuestion = questions.find(function (question) {
                  return question.previousQuestionId === newQuestion.id.toString();
                });

                if (!nextQuestion) {
                  _context.next = 9;
                  break;
                }

                nextQuestion.updatePreviousQuestionId(newQuestion.previousQuestionId);
                return _context.abrupt("return", Result.ok({
                  canceledQuestion: newQuestion.clone(),
                  nextQuestion: nextQuestion
                }));

              case 9:
                return _context.abrupt("return", Result.ok({
                  canceledQuestion: newQuestion.clone()
                }));

              case 10:
                return _context.abrupt("return", new BadInputError('No valid input'));

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function buildUseCase(_x) {
        return _buildUseCase.apply(this, arguments);
      }

      return buildUseCase;
    }()
  }]);

  return CancelQuestionUseCase;
}(UseCase);